import React, { useState, useEffect } from 'react';
import { Key, CheckCircle, AlertCircle } from 'lucide-react';
import HubSpotAuth from '../services/hubspotAuth';

const AuthButton = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = async () => {
    try {
      const auth = new HubSpotAuth();
      const authenticated = auth.isAuthenticated();
      setIsAuthenticated(authenticated);
    } catch (error) {
      console.error('Auth check failed:', error);
      setIsAuthenticated(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAuth = () => {
    const auth = new HubSpotAuth();
    const authUrl = auth.getAuthorizationUrl();
    window.location.href = authUrl;
  };

  const handleLogout = () => {
    const auth = new HubSpotAuth();
    auth.clearTokens();
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return (
      <div style={styles.container}>
        <Key className="w-4 h-4 animate-spin" />
        <span>Checking...</span>
      </div>
    );
  }

  if (isAuthenticated) {
    return (
      <div style={styles.container}>
        <CheckCircle className="w-4 h-4 text-green-400" />
        <span className="text-green-400">HubSpot Connected</span>
        <button
          onClick={handleLogout}
          style={styles.logoutButton}
          className="text-xs opacity-70 hover:opacity-100"
        >
          Disconnect
        </button>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <AlertCircle className="w-4 h-4 text-yellow-400" />
      <button
        onClick={handleAuth}
        style={styles.authButton}
        className="hover:bg-cyan-600 transition-colors"
      >
        Connect HubSpot
      </button>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px'
  },
  authButton: {
    background: '#00d4ff',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '8px 16px',
    fontSize: '14px',
    cursor: 'pointer',
    fontWeight: '500'
  },
  logoutButton: {
    background: 'transparent',
    color: 'inherit',
    border: 'none',
    cursor: 'pointer',
    textDecoration: 'underline'
  }
};

export default AuthButton;